var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg16PxGear(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    "data-color": "color-2",
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    cx: 8,
    cy: 8,
    r: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#444",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M13.5 8c0-.465-.064-.913-.172-1.344l1.917-1.107-1.5-2.598-1.915 1.106A5.476 5.476 0 0 0 9.5 2.713V.5h-3v2.212a5.5 5.5 0 0 0-2.33 1.345L2.255 2.951l-1.5 2.598 1.917 1.107A5.512 5.512 0 0 0 2.5 8c0 .464.064.913.172 1.344L.755 10.451l1.5 2.598 1.916-1.106a5.476 5.476 0 0 0 2.33 1.344V15.5h3v-2.212a5.503 5.503 0 0 0 2.33-1.344l1.916 1.106 1.5-2.598-1.917-1.107c.106-.432.17-.881.17-1.345z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg16PxGear);
export default __webpack_public_path__ + "static/media/16px_gear.e03672f36cb757f84ddca28952739494.svg";
export { ForwardRef as ReactComponent };